<template>
  <div class="relative">
    <Resource
      ref="videoRef"
      :src="src"
      playsinline
      webkit-playsinline
      class="w-full h-full object-cover"
      :muted="true"
      :poster="poster"
      loop
      @play="onPlay"
      @end="onEnd"
      @pause="onPause"
    />
    <div
      v-if="!isPlaying"
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[42px]"
    >
      <iconpark-icon name="playv2"></iconpark-icon>
    </div>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps<{
  src: string
  poster?: string | number
}>()

const emit = defineEmits(['ended'])

const videoRef = ref<HTMLVideoElement>()

const isPlaying = ref(false)

function onPlay() {
  isPlaying.value = true
}

function onEnd() {
  isPlaying.value = false
  emit('ended')
}

function onPause() {
  isPlaying.value = false
}

defineExpose({
  play() {
    videoRef.value?.play()
  },
  pause() {
    videoRef.value?.pause()
  },
})
</script>
<style lang="scss" scoped></style>
